(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var ZONA = 'America/Santiago';
  var CORTE_MOBILE = '(max-width: 767px)';
  var uid = 0;

  var G = { puntaV: 380, puntaA: 1040, centro: 710, separacion: 110, largoLatido: 45, desfase: 0.05 };
  var FILAS = { desde: -2, hasta: 10 };

  function crear(tag, attrs, padre) {
    var n = document.createElementNS(NS, tag);
    for (var a in attrs) n.setAttribute(a, attrs[a]);
    if (padre) padre.appendChild(n);
    return n;
  }
  function linea(x1, y1, x2, y2) { return 'M' + x1 + ' ' + y1 + ' L' + x2 + ' ' + y2; }

  // ---------- Fondo neón ----------
  function dibujarFondo(svg) {
    if (svg.childNodes.length) return;
    var escala = +svg.dataset.escala || 1;
    var id = ++uid;
    var defs = crear('defs', {}, svg);

    var idNeon = 'anCrNeon' + id;
    var f = crear('filter', { id: idNeon, filterUnits: 'userSpaceOnUse', x: -100, y: -400, width: 1640, height: 1200, 'color-interpolation-filters': 'sRGB' }, defs);
    crear('feGaussianBlur', { in: 'SourceGraphic', stdDeviation: 14 * escala, result: 'amplio' }, f);
    crear('feGaussianBlur', { in: 'SourceGraphic', stdDeviation: 5 * escala, result: 'medio' }, f);
    crear('feGaussianBlur', { in: 'SourceGraphic', stdDeviation: 1.5 * escala, result: 'cerca' }, f);
    crear('feMorphology', { in: 'SourceGraphic', operator: 'erode', radius: 0.7 * escala, result: 'fino' }, f);
    crear('feColorMatrix', { in: 'fino', type: 'matrix', values: '0.2 0 0 0 0.8  0 0.2 0 0 0.8  0 0 0.2 0 0.8  0 0 0 1 0', result: 'nucleo' }, f);
    var mezcla = crear('feMerge', {}, f);
    ['amplio', 'amplio', 'medio', 'medio', 'cerca', 'SourceGraphic', 'nucleo'].forEach(function (c) {
      crear('feMergeNode', { in: c }, mezcla);
    });

    var idDeg = 'anCrDeg' + id, idMask = 'anCrMask' + id;
    var lg = crear('linearGradient', { id: idDeg, gradientUnits: 'userSpaceOnUse', x1: 0, y1: 0, x2: 1440, y2: 0 }, defs);
    [[0, .35], [G.puntaV / 1440, 1], [G.centro / 1440, .1], [G.puntaA / 1440, 1], [1, .35]].forEach(function (p) {
      crear('stop', { offset: p[0], 'stop-color': '#fff', 'stop-opacity': p[1] }, lg);
    });
    var mask = crear('mask', { id: idMask, maskUnits: 'userSpaceOnUse', x: -100, y: -300, width: 1640, height: 1000 }, defs);
    crear('rect', { x: -100, y: -300, width: 1640, height: 1000, fill: 'url(#' + idDeg + ')' }, mask);

    var sombra = crear('g', { class: 'nc-sombra', transform: 'translate(0 16)' }, svg);
    var lineas = crear('g', { class: 'nc-lineas' }, svg);
    var barras = crear('g', { class: 'nc-barras' }, svg);
    var luz = crear('g', { class: 'nc-luz', filter: 'url(#' + idNeon + ')' }, crear('g', { mask: 'url(#' + idMask + ')' }, svg));
    var latido = crear('g', { class: 'nc-latido', filter: 'url(#' + idNeon + ')' }, svg);

    for (var fila = FILAS.desde - 1; fila <= FILAS.hasta + 1; fila++) {
      var yV = 60 + G.separacion * fila;
      var yA = yV - (G.puntaA - G.puntaV);
      var retraso = 'animation-delay:' + (-G.desfase * (fila - FILAS.desde)).toFixed(2) + 's';

      var zigzag = 'M' + (G.puntaV - 900) + ' ' + (yV - 900) + ' L' + G.puntaV + ' ' + yV +
                   ' L' + G.puntaA + ' ' + yA + ' L' + (G.puntaA + 900) + ' ' + (yA + 900);
      crear('path', { d: zigzag }, sombra);
      crear('path', { d: zigzag }, lineas);

      if (fila < FILAS.desde || fila > FILAS.hasta) continue;

      var dx = G.centro - G.puntaV;
      [
        linea(G.puntaV, yV, G.puntaV - 400, yV - 400),
        linea(G.puntaV, yV, G.centro, yV - dx),
        linea(G.puntaA, yA, G.centro, yA + dx),
        linea(G.puntaA, yA, G.puntaA + 420, yA + 420)
      ].forEach(function (d) {
        crear('path', { d: d, pathLength: 1, style: retraso }, luz);
      });

      var l = G.largoLatido;
      crear('path', { d: 'M' + (G.puntaV - l) + ' ' + (yV - l) + ' L' + G.puntaV + ' ' + yV + ' L' + (G.puntaV + l) + ' ' + (yV - l), style: retraso }, latido);
      crear('path', { d: 'M' + (G.puntaA - l) + ' ' + (yA + l) + ' L' + G.puntaA + ' ' + yA + ' L' + (G.puntaA + l) + ' ' + (yA + l), style: retraso }, latido);
    }

    [
      { x: 125, y: 700, giro: -45, largo: 757, minimo: .64 },
      { x: 1235, y: -300, giro: 135, largo: 686, minimo: .62 }
    ].forEach(function (b) {
      var g = crear('g', { transform: 'translate(' + b.x + ' ' + b.y + ') rotate(' + b.giro + ')' }, barras);
      var cuerpo = crear('g', { class: 'nc-estira', style: '--min:' + b.minimo }, g);
      crear('rect', { class: 'nc-barra', x: 0, y: -8, width: b.largo, height: 16 }, cuerpo);
      var brillo = crear('g', { class: 'nc-estira', style: '--min:' + b.minimo }, crear('g', { filter: 'url(#' + idNeon + ')' }, g));
      crear('path', { class: 'nc-extremo', d: linea(b.largo, -8, b.largo, 8) }, brillo);
    });
  }

  // ---------- Fecha en hora de Chile (con cambio de horario automático) ----------
  function offsetZona(ms) {
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: ZONA, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = +x.value; });
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - ms;
  }

  function fechaChile(texto) {
    var m = (texto || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) return NaN;
    var local = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    var utc = local - offsetZona(local);
    return local - offsetZona(utc);
  }

  // ---------- Contador ----------
  function iniciarContador(banner, limpiar) {
    var timer = banner.querySelector('.an-cr__timer');
    if (!timer) return;
    var fin = fechaChile(timer.dataset.termina);
    if (isNaN(fin)) {
      console.warn('Banner Contra Reloj: fecha inválida, usa AAAA-MM-DD HH:MM');
      return;
    }

    var celdas = {};
    timer.querySelectorAll('[data-d]').forEach(function (c) { celdas[c.dataset.d] = c; });
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    function pintar(k, v) { if (celdas[k].textContent !== v) celdas[k].textContent = v; }

    function terminar() {
      if (timer.dataset.alTerminar !== 'ocultar' || window.Shopify && Shopify.designMode) return;
      var wrap = banner.closest('.shopify-section') || banner;
      wrap.style.display = 'none';
    }

    function tic() {
      var resta = Math.max(0, Math.floor((fin - Date.now()) / 1000));
      var h = dos(Math.min(99, Math.floor(resta / 3600)));
      var m = dos(Math.floor(resta % 3600 / 60));
      var s = dos(resta % 60);
      pintar('h1', h[0]); pintar('h2', h[1]);
      pintar('m1', m[0]); pintar('m2', m[1]);
      pintar('s1', s[0]); pintar('s2', s[1]);
      return resta;
    }

    if (tic() === 0) return terminar();
    var reloj = setInterval(function () {
      if (tic() === 0) { clearInterval(reloj); terminar(); }
    }, 1000);
    limpiar.push(function () { clearInterval(reloj); });
  }

  // ---------- Carrusel mobile ----------
  function iniciarCarrusel(banner, limpiar) {
    var carrusel = banner.querySelector('.an-cr__carrusel');
    if (!carrusel) return;
    var cada = (parseFloat(carrusel.dataset.cada) || 3) * 1000;
    var pista = carrusel.querySelector('.an-cr__pista');
    var promos = Array.prototype.slice.call(pista.children);
    var puntos = carrusel.querySelector('.an-cr__puntos');
    var mobile = window.matchMedia(CORTE_MOBILE);
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
    var actual = 0, temporizador = null, tocando = false, espera;

    puntos.innerHTML = '';
    var botones = promos.length > 1 ? promos.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'an-cr__punto';
      b.setAttribute('aria-label', 'Ver promoción ' + (i + 1));
      b.addEventListener('click', function () { ir(i); reiniciar(); });
      puntos.appendChild(b);
      return b;
    }) : [];

    function marcar(i) {
      actual = i;
      botones.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function destino(i) {
      var max = pista.scrollWidth - pista.clientWidth;
      return Math.min(max, promos[i].offsetLeft - promos[0].offsetLeft);
    }
    function ir(i) {
      pista.scrollTo({ left: destino(i), behavior: quieto.matches ? 'auto' : 'smooth' });
      marcar(i);
    }
    function reiniciar() {
      clearInterval(temporizador);
      temporizador = null;
      if (mobile.matches && !quieto.matches && !document.hidden && !tocando && promos.length > 1) {
        temporizador = setInterval(function () { ir((actual + 1) % promos.length); }, cada);
      }
    }

    pista.addEventListener('scroll', function () {
      clearTimeout(espera);
      espera = setTimeout(function () {
        var mejor = 0, menor = Infinity;
        promos.forEach(function (_, i) {
          var d = Math.abs(pista.scrollLeft - destino(i));
          if (d < menor) { menor = d; mejor = i; }
        });
        marcar(mejor);
      }, 80);
    }, { passive: true });

    pista.addEventListener('touchstart', function () { tocando = true; reiniciar(); }, { passive: true });
    pista.addEventListener('touchend', function () { tocando = false; reiniciar(); }, { passive: true });

    var alCambiar = function () { pista.scrollLeft = 0; marcar(0); reiniciar(); };
    document.addEventListener('visibilitychange', reiniciar);
    if (mobile.addEventListener) mobile.addEventListener('change', alCambiar); else mobile.addListener(alCambiar);

    limpiar.push(function () {
      clearInterval(temporizador);
      document.removeEventListener('visibilitychange', reiniciar);
      if (mobile.removeEventListener) mobile.removeEventListener('change', alCambiar); else mobile.removeListener(alCambiar);
    });

    marcar(0);
    reiniciar();
  }

  // ---------- Init ----------
  function iniciar(banner) {
    if (banner._anCr) return;
    var limpiar = [];
    banner._anCr = limpiar;
    banner.querySelectorAll('.an-cr__svg').forEach(dibujarFondo);
    iniciarContador(banner, limpiar);
    iniciarCarrusel(banner, limpiar);
  }

  function destruir(banner) {
    if (!banner._anCr) return;
    banner._anCr.forEach(function (fn) { fn(); });
    banner._anCr = null;
  }

  function iniciarTodos(raiz) {
    (raiz || document).querySelectorAll('.an-cr').forEach(iniciar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  else iniciarTodos();

  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.an-cr').forEach(destruir);
  });
})();
